<style lang="less">
</style>
<template>
  <div>
    <Drawer
      :closable="false"
      placement="right"
      v-model="drawerVisible"
      width="50%"
      :title="drawerTitle"
    >
      <Row>
        <Col>
          <Card shadow="false">
            <Row>
              <Form
                ref="form"
                :model="form"
                :label-width="70"
                :rules="formValidate"
                style="position: relative"
              >
                <FormItem label="姓名" prop="userName">
                  <Input v-model="form.userName" autocomplete="off" />
                </FormItem>
                <FormItem label="手机" prop="mobile">
                  <Input v-model="form.mobile" />
                </FormItem>
                <FormItem label="邮箱" prop="email">
                  <Input v-model="form.email" />
                </FormItem>
                <FormItem label="性别" prop="sex">
                  <RadioGroup v-model="form.sex">
                    <Radio :label="2">男</Radio>
                    <Radio :label="1">女</Radio>
                  </RadioGroup>
                </FormItem>

                <FormItem label="摘要" prop="summary">
                  <Input
                    v-model="form.summary"
                    type="textarea"
                    autocomplete="off"
                    maxlength="170"
                  />
                </FormItem>
                <FormItem label="介绍" prop="content">
                  <div ref="editor"></div>
                  <!--<Input v-model="form.content" :rows="8" type="textarea" placeholder="Enter something..." />-->
                </FormItem>

                <Form-item label class="br">
                  <Button @click="editHTML" icon="ios-create-outline"
                    >编辑HTML代码</Button
                  >
                  <Button @click="fullscreenModal = true" icon="md-eye"
                    >预览</Button
                  >
                </Form-item>
                <FormItem label="头像" prop="avatar">
                  <upload-input
                    :fileUrl="form.avatar"
                    fileSize="200"
                    fileWh="100*100"
                    @on-change="handleUpload"
                    width="400px"
                    ref="upload"
                  ></upload-input>
                </FormItem>
                <Form-item class="br">
                  <Button
                    type="primary"
                    :loading="submitLoading"
                    @click="handelSubmit"
                    style="width: 100px"
                    >提交</Button
                  >
                  <Button @click="handelCancel">取消</Button>
                </Form-item>
                <Spin size="large" fix v-if="loading"></Spin>
              </Form>
            </Row>
          </Card>
        </Col>
      </Row>
      <!-- html编辑 -->
      <Modal
        title="编辑html代码"
        v-model="showHTMLModal"
        :mask-closable="false"
        :width="900"
        :fullscreen="full"
      >
        <Input
          v-if="!full"
          v-model="dataEdit"
          :autosize="true"
          type="textarea"
          style="max-height: 60vh; overflow: auto"
        />
        <Input
          v-if="full"
          v-model="dataEdit"
          :autosize="true"
          type="textarea"
        />
        <div slot="footer">
          <Button @click="full = !full" icon="md-expand">全屏开/关</Button>
          <Button
            @click="editHTMLOk"
            type="primary"
            icon="md-checkmark-circle-outline"
            >确定保存</Button
          >
        </div>
      </Modal>
      <Modal title="预览" v-model="fullscreenModal" fullscreen>
        <div v-html="form.content">{{ form.content }}</div>
        <div slot="footer">
          <Button @click="fullscreenModal = false">关闭</Button>
        </div>
      </Modal>
    </Drawer>
  </div>
</template>
<script>
import { uploadFile } from "@/api/index";
import uploadInput from "@/views/my-components/flyme/upload-input";
import { addLecturer, editLecturer, getLecturer } from "@/api/lecturer";
import E from "wangeditor";
// 表情包配置 自定义表情可在该js文件中统一修改
import { sina } from "@/libs/emoji";

let editor = null;
var xss = require("xss");
export default {
  name: "lecturer-drawer",
  components: {
    uploadInput,
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      var reg = /^[1][3,4,5,6,7,8][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      type: 0,
      loading: false, // 表单加载状态
      selectUsers: [],
      drawerTitle: "添加课程",
      drawerVisible: false,
      form: {
        sex: 1,
        userType: "UT_LECTURER",
        avatar: "https://s1.ax1x.com/2018/05/19/CcdVQP.png",
        roleIds: [],
        departmentId: "",
        userName: "",
        mobile: "",
        deptName: "",
        content: "",
        email: "",
        summary: "",
      },
      formValidate: {
        userName: [
          { required: true, message: "账号不能为空", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        email: [
          { required: false, message: "请输入邮箱地址" },
          { type: "email", message: "邮箱格式不正确" },
        ],
      },
      submitLoading: false, // 添加或编辑提交状态
      dataEdit: "", // 编辑数据
      showHTMLModal: false, // 显示html
      full: false, // html全屏开关
      fullscreenModal: false, // 显示全屏预览
    };
  },
  methods: {
    init() {
      this.initEditor();
    },
    showDrawer(params) {
      if (params.id) {
        this.type = 1;
        this.drawerTitle = "编辑讲师";
        this.form.id = params.id;
        this.getData();
      } else {
        this.$refs.form.resetFields();
        this.$refs.upload.setPicUrl("");
        this.drawerTitle = "添加讲师";
        this.type = 0;
      }
      this.drawerVisible = true;
    },
    initEditor() {
      let that = this;
      editor = new E(this.$refs.editor);
      let editorConfig = editor.customConfig
        ? editor.customConfig
        : editor.config;
      editorConfig.onchange = (html) => {
        this.form.content = html;
      };
      editorConfig.uploadImgServer = uploadFile;
      editorConfig.uploadImgHeaders = {
        Authorization: that.getStore("accessToken"),
      };
      editorConfig.uploadFileName = "file";
      editorConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {},
        success: function (xhr, editor, result) {},
        fail: function (xhr, editor, result) {
          that.$Message.error("上传图片失败");
        },
        error: function (xhr, editor) {
          that.$Message.error("上传图片出错");
        },
        timeout: function (xhr, editor) {
          that.$Message.error("上传图片超时");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.status === true) {
            let url = result.data.fileUrl;
            insertImg(url);
            that.$Message.success("上传图片成功");
          } else {
            that.$Message.error(result.info);
          }
        },
      };
      editorConfig.fontNames = ["微软雅黑", "宋体", "黑体", "Arial"];
      editorConfig.emotions = [
        {
          title: "新浪",
          type: "image",
          content: sina,
        },
      ];
      editor.create();
    },
    editHTML() {
      this.dataEdit = this.form.content;
      this.showHTMLModal = true;
    },
    editHTMLOk() {
      editor.txt.html(this.dataEdit);
      this.form.content = xss(this.dataEdit);
      this.showHTMLModal = false;
    },
    getData() {
      this.loading = true;
      getLecturer(this.form.id).then((res) => {
        this.loading = false;

        if (res.status === true) {
          this.form = res.data;
          if (res.data.content == "<p><br></p>") {
            this.form.content = "";
          }
          editor.txt.html(this.form.content);
          this.$refs.upload.setPicUrl(this.form.avatar);
        }
      });
    },
    dataChange(data1, data2) {
      this.form.liveTime = data1;
    },
    handelSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          if (this.type === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            // 用户id数据
            let ids = [];
            this.selectUsers.forEach((e) => {
              ids.push(e.id);
            });
            this.form.lecturerId = ids;
            addLecturer(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.$parent.refreshTable();
                this.drawerVisible = false;
              }
            });
          } else if (this.type === 1) {
            // 编辑
            if (!this.form.avatar) {
              this.form.avatar = "https://s1.ax1x.com/2018/05/19/CcdVQP.png";
            }
            editLecturer(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.$parent.refreshTable();
                this.drawerVisible = false;
              }
            });
          }
        }
      });
    },
    handelCancel() {
      this.drawerVisible = false;
    },
    handleUpload(v) {
      this.form.avatar = v.fileUrl;
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
};
</script>